import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import React from 'react';

import useStyles from './styles';

const ModalContent = ({ children, dividers }) => {
  const classes = useStyles();
  return (
    <DialogContent
      classes={{
        dividers: classes.contentDividers,
        root: classes.content,
      }}
      dividers={dividers}
    >
      {children}
    </DialogContent>
  );
};

ModalContent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  dividers: PropTypes.bool,
};

ModalContent.defaultProps = {
  dividers: true,
};

export default ModalContent;
